<template>
    <div class="mb-3">
        <TelegramChallenge v-if="challenge" :initial="challenge" :scope="scope" :password="password" @authenticated="verified" @cancel="challenge = null"/>
        <button v-else type="button" class="btn btn-outline-primary" :disabled="busy || !password" @click="start">{{ done ? 'Подтвердить Telegram ещё раз' : 'Подтвердить Telegram для изменения' }}</button>
        <p v-if="done" class="text-success mt-2" role="status">Telegram подтверждён на 5 минут.</p>
        <p v-if="error" class="alert alert-danger mt-2" role="alert">{{ error }}</p>
    </div>
</template>
<script>
import TelegramChallenge from './TelegramChallenge.vue';
import {securityRequest} from '@/utils/sessionSecurity';
export default {
    components: {TelegramChallenge}, props: {scope: {type: String, default: 'staff'}, password: {type: String, default: ''}},
    data() { return {challenge: null, busy: false, error: '', done: false}; },
    methods: {
        async start() {
            this.busy = true; this.error = '';
            try { this.challenge = await securityRequest(this.scope, 'stepup', {password: this.password}); }
            catch (error) { this.error = error.response?.data?.msg || 'Не удалось подтвердить пароль.'; }
            finally { this.busy = false; }
        },
        verified() { this.challenge = null; this.done = true; this.$emit('verified'); }
    }
};
</script>
